<div class="pb-50 pt-80">
    <div class="row ">
        <app-article [pageName]="'MY_SCHOOL'" (pageTeacherDataLoaded)="handlePageData($event)"></app-article>
        <div class="col-lg-8 col-md-8 col-12  mt-20">
            <h5 class="text-regular-bold fs-20">My Schools</h5>
            <div class="history-description mt-20">
                <div class="row mt-20 sub-header">
                    <div class="col-lg-8 col-md-8 left-content">
                        <div *ngIf="mySchoolsData?.length > 0" class="d-flex align-items-center">
                            <input #checkAll [(ngModel)]="selectAllCheck" (change)="selectAll('All', $event)"
                                class="form-check-input mt-0 mr-5" appFocus appClick id="checkAll" type="checkbox"
                                [ngModelOptions]="{ standalone: true }" />
                            <label class="form-check-label mt-4 mr-20" for="checkAll">
                                <span class="h_b">Select all</span>
                            </label>
                            <!-- <p class="txt-regular mr-20">Select all</p> -->
                            <div class="selected-data c-p">
                                <span class="text-r-m-16">{{ getSelectedTeachersCount() }} Selected</span>
                            </div>
                            <div class="selected-data c-p ml-10" *ngIf="getSelectedTeachersCount() > 0">
                                <span class="text-r-g-3" (click)="clearSelectedTeachers()"><svg
                                        xmlns="http://www.w3.org/2000/svg" width="15" height="16" fill="currentColor"
                                        class="bi bi-x-lg" viewBox="0 0 16 19">
                                        <path
                                            d="M2.146 2.854a.5.5 0 1 1 .708-.708L8 7.293l5.146-5.147a.5.5 0 0 1 .708.708L8.707 8l5.147 5.146a.5.5 0 0 1-.708.708L8 8.707l-5.146 5.147a.5.5 0 0 1-.708-.708L7.293 8z" />
                                    </svg>
                                    Clear selected</span>
                            </div>
                        </div>
                    </div>
                    @if(mySchoolsData?.length > 0){
                    <div class="col-lg-4 col-md-4">
                        <div class="d-flex lign-items-center justify-content-end">
                            <a role="button" appClick [appFocus]="hideButton ? '-1' : '0'"
                                [ngClass]="!hideButton ? '' : 'input-cursor-na'" (click)="onDeregisterClick('')"
                                class="h_b d-flex align-items-center fs-15 clr-cc-vilot text-regular-medium ml-10 c-p"
                                aria-label="Resend selected">
                                <svg xmlns="http://www.w3.org/2000/svg" width="25" height="14" fill="currentColor"
                                    class="bi bi-archive" viewBox="0 0 12 17">
                                    <path
                                        d="M0 2a1 1 0 0 1 1-1h14a1 1 0 0 1 1 1v2a1 1 0 0 1-1 1v7.5a2.5 2.5 0 0 1-2.5 2.5h-9A2.5 2.5 0 0 1 1 12.5V5a1 1 0 0 1-1-1zm2 3v7.5A1.5 1.5 0 0 0 3.5 14h9a1.5 1.5 0 0 0 1.5-1.5V5zm13-3H1v2h14zM5 7.5a.5.5 0 0 1 .5-.5h5a.5.5 0 0 1 0 1h-5a.5.5 0 0 1-.5-.5"
                                        stroke="currentColor" stroke-width="1" />
                                </svg>Deregister selected</a>
                        </div>
                    </div>
                    }
                </div>
            </div>
            @if(mySchoolsData?.length > 0){
            @for(data of mySchoolsData; track data.school.id) {
            <div class="card mt-15 px-20">
                <div class="row">
                    <div class="col-lg-8 col-md-8 col-12">
                        <div class="col-md-12 col-lg-12 d-flex">
                            <div class="pic-and-check">
                                <input appClick appFocus (change)="selectAll(data, $event)" [checked]="data.isChecked"
                                    id="{{ data.id }}" [attr.aria-label]="data.school.title"
                                    class="form-check-input mr-10 c-p" type="checkbox">
                            </div>
                            <div class="pic-and-check ml-0">
                                <img alt="img"
                                    [src]="data.school.profile_image == '' || data.school.profile_image == null ? '../../../../assets/images/teacher-static-profile.png' : data.school.profile_image"
                                    class="profile-picture img-complete-match">
                            </div>
                            <div class="pic-and-check ml-10">
                                <div class="d-flex">
                                    <p>
                                        <a (click)="openPublicProfile(data.school.slug)" role="button"
                                            aria-label="Teacher Profile Info" class="s_n user-title" appFocus
                                            appClick>{{data.school.title}}</a>
                                    </p>
                                </div>
                                <p class="txt-regular">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="11" height="14" fill="currentColor"
                                        stroke="#3A0CA3" stroke-width="1" class="bi bi-geo-alt" viewBox="0 0 15 19">
                                        <path
                                            d="M12.166 8.94c-.524 1.062-1.234 2.12-1.96 3.07A32 32 0 0 1 8 14.58a32 32 0 0 1-2.206-2.57c-.726-.95-1.436-2.008-1.96-3.07C3.304 7.867 3 6.862 3 6a5 5 0 0 1 10 0c0 .862-.305 1.867-.834 2.94M8 16s6-5.686 6-10A6 6 0 0 0 2 6c0 4.314 6 10 6 10" />
                                        <path d="M8 8a2 2 0 1 1 0-4 2 2 0 0 1 0 4m0 1a3 3 0 1 0 0-6 3 3 0 0 0 0 6" />
                                    </svg> {{data.school.address.city}}
                                </p>
                                <p class="txt-regular">
                                    <span>
                                        <svg xmlns="http://www.w3.org/2000/svg" width="14" height="20"
                                            fill="currentColor" class="bi bi-person" viewBox="0 0 15 20"
                                            stroke="#3A0CA3" stroke-width="1">
                                            <path
                                                d="M8 8a3 3 0 1 0 0-6 3 3 0 0 0 0 6m2-3a2 2 0 1 1-4 0 2 2 0 0 1 4 0m4 8c0 1-1 1-1 1H3s-1 0-1-1 1-4 6-4 6 3 6 4m-1-.004c-.001-.246-.154-.986-.832-1.664C11.516 10.68 10.289 10 8 10s-3.516.68-4.168 1.332c-.678.678-.83 1.418-.832 1.664z" />
                                        </svg> {{data.school.rta_user.full_name}}
                                    </span>
                                    <span class="divider-right ml-3 mr-5">
                                    </span>
                                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor"
                                        stroke="#3A0CA3" stroke-width="1" class="bi bi-telephone" viewBox="0 0 15 19">
                                        <path
                                            d="M3.654 1.328a.678.678 0 0 0-1.015-.063L1.605 2.3c-.483.484-.661 1.169-.45 1.77a17.6 17.6 0 0 0 4.168 6.608 17.6 17.6 0 0 0 6.608 4.168c.601.211 1.286.033 1.77-.45l1.034-1.034a.678.678 0 0 0-.063-1.015l-2.307-1.794a.68.68 0 0 0-.58-.122l-2.19.547a1.75 1.75 0 0 1-1.657-.459L5.482 8.062a1.75 1.75 0 0 1-.46-1.657l.548-2.19a.68.68 0 0 0-.122-.58zM1.884.511a1.745 1.745 0 0 1 2.612.163L6.29 2.98c.329.423.445.974.315 1.494l-.547 2.19a.68.68 0 0 0 .178.643l2.457 2.457a.68.68 0 0 0 .644.178l2.189-.547a1.75 1.75 0 0 1 1.494.315l2.306 1.794c.829.645.905 1.87.163 2.611l-1.034 1.034c-.74.74-1.846 1.065-2.877.702a18.6 18.6 0 0 1-7.01-4.42 18.6 18.6 0 0 1-4.42-7.009c-.362-1.03-.037-2.137.703-2.877z" />
                                    </svg> {{data.school.phone_number}}
                                </p>
                            </div>
                        </div>
                        @if(data?.is_deregister_access) {
                        <div class="col-lg-12 col-md-12 col-12 mt-20">
                            <h5 class="user-title ">Appear available</h5>
                            <div class="job__alerts d-flex align-items-center  mt-10">
                                <div class="form-check form-switch ">
                                    <input type="checkbox" role="switch" id="availability-switch-{{data.school.id}}"
                                        [checked]="data.is_available"
                                        (change)="onAvailabilitySwitchChange(data.school.id, $event,'appear_action')"
                                        class="form-check-input delay-send form__switch_cc c-p">
                                </div>

                                <div class="ml-5">
                                    <p class="txt-regular">
                                        When disabled, this school will be unable to find and book you.
                                    </p>
                                </div>
                            </div>
                        </div>
                        <div class="col-lg-12 col-md-12 col-12 mt-20">
                            <h5 class="user-title ">Pre-confirmed bookings</h5>
                            <div class="job__alerts d-flex align-items-center mt-10">
                                <div class="form-check form-switch ">
                                    <input type="checkbox" role="switch" id="pre-confirmed-switch-{{data.school.id}}"
                                        [checked]="data.enable_preconfirmed"
                                        (change)="onAvailabilitySwitchChange(data.school.id, $event, 'preconfirm_action')"
                                        class="form-check-input delay-send form__switch_cc c-p">
                                </div>

                                <div class="ml-5">
                                    <p class="txt-regular">
                                        Allow school to book you using pre-confirmed bookings.
                                    </p>
                                </div>
                            </div>
                        </div>
                        }
                    </div>
                        <div class="col-lg-4 col-md-4 col-12">
                            <div class="accept-decline text-right">
                                @if(data?.school?.is_set_preferrence) {
                                    <a class="text-regular-bold clr-cc-vilot c-p me-2" [ngClass]="hideButton ? '' : 'disabled'"
                                    (click)="setPreferenceModal(data)">Set preferences</a>
                                }
                                @if(data?.is_deregister_access) {
                                    <button class="text-regular-bold btn-outline clr-cc-vilot c-p" [ngClass]="hideButton ? '' : 'disabled'" (click)="onDeregisterClick(data.school.id)">Deregister</button>
                                }
                            </div>
                        </div>
                </div>
            </div>
            }
            }
            @if (mySchoolsData?.length === 0) {
            <div class="card px-30">
                <div class="text-center mt-20">
                    <p>
                        <img style="width: 200px;" src="assets/CC_NotRegistered_FindSchool 1.png"
                            alt="No invites found!" />
                    </p>
                    <p id="noSchoolsHeading" class="title pl-50 pr-50">
                        You are not registered with any schools. Search schools in your area and request to be added to
                        their list.
                    </p>
                    <button aria-describedby="noSchoolsHeading" (click)="findNewSchools()"
                        class="btn cc_p_btn mt-20">Find new schools</button>
                </div>
            </div>
            }
            <div class="row">
                <div class="col-lg-12">
                    <pagination *ngIf="mySchoolsData?.length > 0" class="mt-20" [totalItems]="totalCount"
                        class="pagination-sm mt-20" [boundaryLinks]="true" [rotate]="true" [maxSize]="5"
                        [(ngModel)]="page" (pageChanged)="pageChanged($event)">
                    </pagination>
                </div>
            </div>
        </div>
        <div class="col-lg-4 col-md-4 col-12">
            <div class="d-flex justify-content-between align-items-center mt-20">
            </div>
            <div class="card px-15 ">
                <div class="row align-items-center">
                    <div class="col-lg-12 col-md-12 col-sm-12 col-12">
                        <h5 class="user-title fs-18">My Schools</h5>
                        <div class="d-flex align-items-center">
                            <div>
                                <h2 class="mb-0 text-regular-medium fs-32 clr-cc-vilot">{{ schoolCount }}</h2>
                            </div>
                            <div>
                                <p class="txt-regular fs-16 ml-10">
                                    {{schoolProps.properties.is_qld_teacher? 'Schools are part of your My schools list' : 'Schools have added you to their list.'}}
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <section class="card px-15 mt-20 d-flex flex-row align-items-center justify-content-between"
                aria-labelledby="findSchoolsHeading">

                <div class="flex-grow-1">

                    <h5 id="findSchoolsHeading" class="user-title fs-18 mb-0 mt-3">
                        Find new schools on ClassCover
                    </h5>

                    <p id="findSchoolsDesc" class="txt-regular mt-5 mb-5">
                        Search schools in your area and request to be added to their list.
                    </p>

                    <button type="button" (click)="findNewSchools()" class="clr-cc-vilot fs-16 text-regular-bold"
                        aria-describedby="findSchoolsDesc" aria-label="Find new schools in your area">
                        Find new schools
                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor"
                            class="bi bi-arrow-right" viewBox="0 0 16 17" stroke="currentColor" stroke-width="1"
                            aria-hidden="true" focusable="false">
                            <path fill-rule="evenodd"
                                d="M1 8a.5.5 0 0 1 .5-.5h11.793l-3.147-3.146a.5.5 0 0 1 .708-.708l4 4a.5.5 0 0 1 0 .708l-4 4a.5.5 0 0 1-.708-.708L13.293 8.5H1.5A.5.5 0 0 1 1 8" />
                        </svg>
                    </button>

                </div>

                <img class="img-fluid" style="max-width: 150px; height: 120px;"
                    src="assets/PendingInvites_NoHistoryFound.png" alt="Illustration of searching for schools">

            </section>
            <section class="card px-15 mt-20 d-flex flex-row align-items-center justify-content-between"
                aria-labelledby="referSchoolHeading">

                <div class="flex-grow-1">

                    <h5 id="referSchoolHeading" class="user-title mb-0 mt-3 fs-18">
                        Refer a new school
                    </h5>

                    <p id="referSchoolDesc" class="txt-regular mt-5 mb-5">
                        Want to connect with a school that isn't on ClassCover?
                        Refer them and get rewarded when they sign up.
                    </p>

                    <a href="https://rtcon.typeform.com/to/i7ildpN3?typeform-source=app.classcover.com.au"
                        target="_blank" rel="noopener noreferrer" class="clr-cc-vilot fs-16 text-regular-bold"
                        aria-describedby="referSchoolDesc" aria-label="Refer a school (opens in new tab)">
                        Refer a school
                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor"
                            class="bi bi-arrow-right" viewBox="0 0 16 17" stroke="currentColor" stroke-width="1"
                            aria-hidden="true" focusable="false">
                            <path fill-rule="evenodd"
                                d="M1 8a.5.5 0 0 1 .5-.5h11.793l-3.147-3.146a.5.5 0 0 1 .708-.708l4 4a.5.5 0 0 1 0 .708l-4 4a.5.5 0 0 1-.708-.708L13.293 8.5H1.5A.5.5 0 0 1 1 8" />
                        </svg>
                    </a>

                </div>

                <img class="img-fluid" style="max-width: 150px; height: 120px;" src="assets/Nosortlisted.png"
                    alt="Illustration of referring a school">

            </section>
        </div>
    </div>
</div>
<ng-template #deregisterModal>
    <form>
        <div class="modal-header">
            <h4 class="modal-title">Deregister School</h4>
            <button type="button" (click)="bsModalRef.hide()" class="btn-close" aria-label="Close"></button>
        </div>
        <div class="modal-body pb-0">
            <div class="row align-items-center">
                <div class="col-md-12">
                    @if(this.filterType === 'deregister_bulk'){
                    <p class="txt-regular mt-10">Are you sure you want to deregister from selected schools?
                    </p>
                    <!-- <p class="txt-regular mt-10">The School will receive an email confirmation of this action.</p> -->
                    } @else {
                    <p class="txt-regular mt-10">Are you sure you want to deregister from {{selectedSchoolName}}?
                    </p>
                    <!-- <p class="txt-regular mt-10">The School will receive an email confirmation of this action.</p> -->
                    }
                </div>
            </div>
        </div>
        <div class="modal-footer mt-10">
            <button type="button" (click)="appearAvailable(this.filterType)" class="btn cc_p_btn fs_13">
                Confirm
            </button>
        </div>
    </form>
</ng-template>
<ng-template #actionTeacherModalTemplate>
    <form>
        <div class="modal-header">
            <h4 class="modal-title" id="exampleModalLabel">{{ confirmationHeading }}</h4>
            <button type="button" (click)="restoreSwitchState(); bsModalRef.hide()" class="btn-close"
                aria-label="Close"></button>
        </div>

        <div class="modal-body pb-0">
            <div class="row align-items-center">
                <div class="col-md-12">
                    <ng-container *ngFor="let text of confirmationText">
                        <p class="txt-regular mt-10">{{ text }}</p>
                    </ng-container>
                </div>
            </div>
            <div class="row mt-20">

            </div>
        </div>
        <div class="modal-footer mt-10">
            <button type="button" (click)="appearAvailable('')" class="btn cc_p_btn fs_13">
                Confirm
            </button>
        </div>
    </form>
</ng-template>

<ng-template #setPreferenceModalTemplate>
    <div class="modal-header">
        <h5 class="modal-title">Set Preferences for {{selectedSchool?.school?.title}}</h5>
        <button type="button" class="btn-close" (click)="bsModalRef.hide()" aria-label="Close"></button>
    </div>

    <div class="modal-body pb-0">
        <form [formGroup]="preferenceForm">
            <h3>Preferred year level</h3>
            <div class="row">
                <div *ngFor="let level of yearLevels" class="col-6">
                    <label>
                        <input type="checkbox" name="preferred_year_level" class="form-check-input me-1"
                            [value]="level.value" (change)="onYearLevelChange($event)"
                            [checked]="preferenceForm.value.preferred_year_level.includes(level.value)" />
                        {{ level.label }}
                    </label>
                </div>
            </div>

            <!-- ✅ Error for Preferred Year -->
            <div class="text-danger mt-1"
                *ngIf="preferenceForm.get('preferred_year_level')?.touched &&preferenceForm.get('preferred_year_level')?.invalid">
                Please select at least one preferred year level.
            </div>

            <h3 class="mt-8">Work type preferences</h3>
            <div>
                <label>
                    <input type="checkbox" class="form-check-input me-1" value="C" (change)="onWorkTypeChange($event)"
                        [checked]="preferenceForm.value.work_type.includes('C')" />
                    Casual
                </label>

                <label class="ms-3">
                    <input type="checkbox" name="work_type" class="form-check-input" value="T"
                        (change)="onWorkTypeChange($event)" [checked]="preferenceForm.value.work_type.includes('T')" />
                    Temporary/Contract
                </label>
            </div>

            <!-- ✅ Error for Work Type -->
            <div class="text-danger mt-1"
                *ngIf="preferenceForm.get('work_type')?.touched &&preferenceForm.get('work_type')?.invalid">
                Please select at least one work type.
            </div>

        </form>


    </div>

    <hr class="mt-10 mb-10" />

    <div class="modal-footer justify-content-end">
        <button type="button" class="btn cc_p_btn fs_13" (click)="saveSchoolPreferences()"
            [disabled]="preferenceForm.invalid">
            Save
        </button>
    </div>
</ng-template>